<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('sociocultural representations')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      :page_length="50"
      :extra_data="{ hall_uuid: $route.params.hall_uuid }"
      resource_url="/museum/representation/datatables"
      mode="grid"
      grid_class="is-col-min-10"
      ><template #item="item">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto">
              <v-lazy-image
                v-if="item.image"
                :src="`${api_host}/drive/static/${item.image}`"
              />
              <img
                v-else
                src="https://icon-library.com/images/product-icon-png/product-icon-png-11.jpg"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <div class="title is-5 has-text-centered">
                  {{ item.name }}
                </div>
                <!-- <div class="subtitle is-6 has-text-centered">
                  <span class="tag is-primary is-medium">{{
                    format_currency(item.sale_price)
                  }}</span>
                </div> -->
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
          </footer>
        </div> </template
    ></generic-table>
  </div>

  <representation-modal ref="representation_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  api_host,
} from "@/utils";
import RepresentationModal from "./representation_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "RepresentationDatatable",
  components: { GenericTable, RepresentationModal, VLazyImage },
  props: {
    // module_settings: {
    //   type: Object,
    //   required: true,
    // },
  },
  data() {
    let v = this;
    return {
      api_host,
      extra_buttons: [
        {
          text: v.$t("add"),
          icon: "fa fa-plus",
          class: "is-secondary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("barcode"),
          name: "barcode",
          width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.barcode || "";
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.product_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete product?"),
                    v,
                    () => {
                      del("/product", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.representation_modal.show_modal();
    },
    bulk_categorize() {
      let v = this;
      v.$refs.bulk_categorize_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit(item) {
      let v = this;
      v.$refs.representation_modal.edit_modal(item.uuid);
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete representation?"),
        v,
        () => {
          del("/museum/representation", { uuid: item.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
  },
  mounted() {
    let v = this;
    v.refresh();
    // window.new_product = () => {
    //   v.create();
    // };
  },
};
</script>

<style></style>
